import React from 'react'

import { IShapes } from '..'
import { LeftHalfSemicircle } from './LeftHalfSemicircle'
import { RightHalfSemicircle } from './RightHalfSemicircle'
import { Semicircle } from './Semicircle'

export const shapeSizes = {
  tiny: 84,
  small: 124,
  medium: 200,
  large: 280,
  huge: 360,
}

export const Shape = ({ shape, size, color }: IShapes): React.ReactElement => {
  switch (shape) {
    case 'semicircle':
      return <Semicircle className="shape-section__shape" size={size} color={color} />
    case 'left-half-semicircle':
      return <LeftHalfSemicircle className="shape-section__shape" size={size} color={color} />
    case 'right-half-semicircle':
      return <RightHalfSemicircle className="shape-section__shape" size={size} color={color} />
    default:
      return <Semicircle className="shape-section__shape" size={size} color={color} />
  }
}
